module.exports = __webpack_public_path__ + "assets/logo_qlik.581f0637.svg";